import { create } from "zustand"
import type { TDeleteCategory, TObjectCategoryDrawerStore } from "types/configuration.type"

// Delete category
export const useDeleteCategoryStore = create<TDeleteCategory>((set) => ({
	isDeleteCategoryModalOpen: false,
	deleteCategoryData: {
		categoryName: "",
		deletionWarningText: "",
		categoryId: undefined,
	},

	setDeleteCategoryModalClose: () => set(() => ({ isDeleteCategoryModalOpen: false })),
	setDeleteCategoryModalOpen: () => set(() => ({ isDeleteCategoryModalOpen: true })),

	setDeleteCategoryData: ({ categoryName, deletionWarningText, categoryId }) =>
		set(() => ({ deleteCategoryData: { categoryName, deletionWarningText, categoryId } })),
}))

// Category object drawer
export const useObjectCategoryDrawerStore = create<TObjectCategoryDrawerStore>((set) => ({
	objectCategoryStore: {
		name: "",
		id: null,
		type: "",
		label: "",
		inModelTrain: null,
		inProcessingResult: null,
		objectCount: null,
		dimensions: {},
		recipes: [],
	},
	setObjectCategory: (category) =>
		set(() => ({
			objectCategoryStore: category,
			modelNumberToId: {},
		})),
	modelNumberToId: {},
	setModelNumberToId: (map) => set(() => ({ modelNumberToId: map })),
	isDrawerOpen: false,
	triggerDrawer: () =>
		set((state) => ({
			isDrawerOpen: !state.isDrawerOpen,
		})),
}))
